export default __webpack_public_path__ + "static/media/misc-makeupA-1024w.98ebcb34.avif";